import React, { FC, useContext, useEffect, useRef, useState } from "react";
//import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


//import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
//'import Avatar from "./Avatar";
//import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate, useParams } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { ArrowSmallLeftIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";
import PictureUpload from "./PictureUpload";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}


const Logo = () => (
	<svg className="icon" x="0px" y="0px" viewBox="0 0 24 24">
	  <path fill="transparent" d="M0,0h24v24H0V0z"/>
	  <path fill="#000" d="M20.5,5.2l-1.4-1.7C18.9,3.2,18.5,3,18,3H6C5.5,3,5.1,3.2,4.8,3.5L3.5,5.2C3.2,5.6,3,6,3,6.5V19  c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V6.5C21,6,20.8,5.6,20.5,5.2z M12,17.5L6.5,12H10v-2h4v2h3.5L12,17.5z M5.1,5l0.8-1h12l0.9,1  H5.1z"/>
	</svg>
  );
  const FileInfo = ({ uploadedInfo }: any) => (
	<ul className="preview_info">
	  {Object.entries(uploadedInfo).map(([key, value]) => (
		<li key={key}>
		  <span className="info_key">{key}</span>
		  <span className="info_value">value</span>
		</li>
	  ))}
	</ul>
  );


const ReservationModifyLicense: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const { id, idx } = useParams();

	const buttonRef = useRef (null);

	const navigate = useNavigate ();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const [ licenseUrl, setLicenseUrl ] = useState <any> ("");
	const [ licenseUrl2, setLicenseUrl2 ] = useState <any> ("");
	


	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate(`/reservation/${id}`);
		} else {
			(async () => {

				const res: any = await requestAPI('GET', `v1/reserve/${id}`, null);

				const traveler = res.data.info.traveler[Number(idx)];
				console.log(traveler)
				setLicenseUrl(traveler.licenseUrl===null?"":traveler.licenseUrl);
				setLicenseUrl2(traveler.licenseUrl2===null?"":traveler.licenseUrl2);
			})();
		}
		
	}, []);


	
	const handleBack = () => {
		navigate(`/reservation/${id}`);
	}

	return (
		<>
			
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>

				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									운전면허 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />
						
						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경하실 운전면허를 올려주세요
							</span>
						</div>
						

						<div className="mt-10" />

						<div className="mt-10 md:ml-10 md:mr-10">
							<PictureUpload
								type={"license_front"}
								productId={id}
								travelerNo={idx}
								label={"운전면허 앞면"} 
								url={licenseUrl}
							/>
						</div>
						<div className="mt-10 md:ml-10 md:mr-10">
							<PictureUpload
								type={"license_back"}
								productId={id}
								travelerNo={idx}
								label={"운전면허 뒷면"} 
								url={licenseUrl2}
							/>
						</div>
					</div>

				</div>
				
			</div>
		</>
	);
};

export default ReservationModifyLicense;
